import { IdentityApiService } from '@api_patient/identity_api.service';
import { withTranslation } from '@application/i18n/with_translation';
import { UniversalConfig } from '@application/universal_config.service';
import { Button } from '@cellula/react';
import { useResolve } from '@visiba/instantiation';

export function AuthSignOutButton() {
	const universalConfig = useResolve(UniversalConfig);
	const identityApiService = useResolve(IdentityApiService);

	return (
		<form
			action={identityApiService.getSignOutPath(`${universalConfig.alias}`)}
			method='post'
			style={{
				display: 'contents',
			}}
		>
			<Button type='submit' variant='primary' size='medium'>
				{withTranslation('Common.Button.SignOut')}
			</Button>
		</form>
	);
}
